import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGuidelines = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 11.9997L11 13.9997L15.5 9.49969M9.40073 2.15491L5.85055 3.73276C4.81875 4.19133 4.30286 4.42062 3.92457 4.78305C3.59019 5.10342 3.33451 5.49684 3.17756 5.93252C3 6.4254 3 6.98995 3 8.11906V13.5745C3 14.8268 3 15.4529 3.1726 16.0213C3.32541 16.5244 3.57592 16.9925 3.90982 17.3988C4.28697 17.8577 4.80796 18.205 5.84992 18.8996L9.33744 21.2246C10.2997 21.8661 10.7808 22.1869 11.3009 22.3115C11.7605 22.4217 12.2395 22.4217 12.6991 22.3115C13.2192 22.1869 13.7003 21.8661 14.6626 21.2246L18.1501 18.8996C19.192 18.205 19.713 17.8577 20.0902 17.3988C20.4241 16.9925 20.6746 16.5244 20.8274 16.0213C21 15.4529 21 14.8268 21 13.5745V8.11906C21 6.98995 21 6.4254 20.8224 5.93252C20.6655 5.49684 20.4098 5.10342 20.0754 4.78305C19.6971 4.42062 19.1812 4.19133 18.1495 3.73276L14.5993 2.15491C13.6421 1.72951 13.1635 1.5168 12.666 1.4328C12.2251 1.35834 11.7749 1.35834 11.334 1.4328C10.8365 1.5168 10.3579 1.72951 9.40073 2.15491Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGuidelines;
